<div class="card">

  <div class="card-header">
    <label class="form-control-label text-break" [ngClass]="{ 'required-field-label': required }">{{getTitle()}} </label>
    <div *ngIf="!canAddCustomerCriteria()" class="warning-text">
      {{'FORM_RECORD_CUSTOMER_RECORD_NO_PARENT_SELECTED' | translate}}
    </div>
    <div class="card-actions">
      <a class="btn-setting cursor-pointer" (click)="openAddDialog()"
         *ngIf="canAdd()"
         title="{{'COMMON_BUTTON_ADD' | translate}}"><i class="icomoon icomoon-multiselect-3"></i></a>
      <a class="btn-setting cursor-pointer" (click)="openCreateDialog()"
         *ngIf="canCreate()"
         title="{{'COMMON_BUTTON_CREATE' | translate}}"><i class="icomoon icomoon-add"></i></a>
    </div><!-- /.card-actions -->
  </div>
  <div class="card-body">
    <label class="warning-text"
           *ngIf="!optionalValue && htmlForm && htmlForm.getForm().submitted && (!model.values || model.values.length === 0)">{{'FORM_RECORD_CUSTOMER_REQUIRED_WARNING_TEXT' | translate}}</label>
    <div class="text-center text-muted p-2" *ngIf="model.values.length === 0">
      <div style="background-image: url('../../../../../../assets/img/stock/stock-item-placeholder.png')"
           class="record-picture"></div>
      <label class="mb-1" *ngIf="!nonEditable">{{'FORM_RECORD_CUSTOMER_NO_ITEM' | translate}}</label>
      <br>
      <button type="button" class="btn btn-secondary"
              *ngIf="canAdd()"
              (click)="openAddDialog()">
        {{'COMMON_BUTTON_ADD' | translate}}
      </button>
      <label class="m-0" *ngIf="nonEditable">{{'FORM_RECORD_CUSTOMER_NO_ITEM_READONLY' | translate}}</label>
    </div>
    <div *ngIf="model.values.length > 0">
      <table class="table table-sm table-bordered mb-0 table-striped">
        <thead>
        <tr>
          <th class="responsive-table-column">{{'COMMON_NAME' | translate}}</th>
          <th class="responsive-table-column">{{'COMMON_EXTERNAL_ID' | translate}}</th>
          <th
            class="responsive-table-column hidden-md-down">{{'COMMON_EMAIL_ADDRESS' | translate}}</th>
          <th
            class="responsive-table-column hidden-md-down">{{'COMMON_PHONE_NUMBER' | translate}}</th>
          <th class="responsive-table-column w-table-options-menu"></th>
        </tr>
        </thead>
        <tbody *ngFor="let item of model.values; let idx = index;">
        <tr [ngClass]="{'disabled-item': item.disabled}">
          <td class="responsive-table-column">
            <i
              class="icomoon icomoon-geocode-partial-alt"
              *ngIf="!customerMatches(item) || !locationMatches(item)"></i>
            <a class="id-text cursor-pointer"
               href="#" onclick="return false"
               uiSref="Admin.CustomerRecordDetail"
               [uiParams]="{ customerId: customerId, customerRecordId: item.customerRecordId }"
               title="{{'COMMON_BUTTON_DETAILS' | translate}}">
              {{item.name}}
            </a>
          </td>
          <td class="responsive-table-column">
            <a class="id-text cursor-pointer"
               href="#" onclick="return false"
               uiSref="Admin.CustomerRecordDetail"
               [uiParams]="{ customerId: customerId, customerRecordId: item.customerRecordId }"
               title="{{'COMMON_BUTTON_DETAILS' | translate}}">
              {{item.externalId}}
            </a>
          </td>
          <td class="responsive-table-column hidden-md-down">
            <div *ngIf="item.firstEmailAddress">
              <div>
                {{item.firstEmailAddress.value.format()}}
              </div>
              <div class="table-text-subtitle">
                {{getEmailAddressTypeName(item.firstEmailAddress)}}
              </div>
            </div>
          </td>
          <td class="responsive-table-column hidden-md-down">
            <div *ngIf="item.firstPhoneNumber">
              <div>
                {{item.firstPhoneNumber.value.format()}}
              </div>
              <div class="table-text-subtitle">
                {{('COMMON_PHONE_NUMBER_TYPE_' + item.firstPhoneNumber.type) | translate}}
              </div>
            </div>
          </td>
          <td class="align-middle">
            <app-table-options-menu>
              <app-dropdown-item
                *ngIf="item.rights.read.hasRight()"
                [iconClass]="'icomoon-detail'"
                [titleStringKey]="'COMMON_BUTTON_DETAILS'"
                class="cursor-pointer"
                uiSref="Admin.CustomerRecordDetail"
                [uiParams]="{ customerId: customerId, customerRecordId: item.customerRecordId }">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="item.rights.update.hasRight()"
                [iconClass]="'icomoon-modify'"
                [titleStringKey]="'COMMON_BUTTON_EDIT'"
                class="cursor-pointer"
                uiSref="Admin.CustomerRecordEdit"
                [uiParams]="{ customerId: customerId, customerRecordId: item.customerRecordId }">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="!nonEditable"
                [iconClass]="'icomoon-trash'"
                [titleStringKey]="'COMMON_BUTTON_DELETE'"
                class="cursor-pointer"
                (click)="removeCustomer(idx)">
              </app-dropdown-item>
            </app-table-options-menu>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
